export default __webpack_public_path__ + "static/media/insta.c8bcd9e6.svg";